<script context='module'>
  import { append } from 'ramda';
  import { getContext } from 'svelte';
  import { writable, get } from 'svelte/store';

  export const DROPDOWNS = Symbol('Dropdowns');

  class Entry {
    constructor(
      context,
      element,
      dispatch,
      {
        anchor,
        gravity,
        className,
        clickThrough,
      },
    ) {
      this.context = context;
      this.element = element;
      this.dispatch = dispatch;
      this.anchor = anchor;
      this.gravity = gravity;
      this.className = className;
      this.clickThrough = clickThrough;
    }

    show() {
      this.assertContextIsPresent();
      if (!get(this.context).includes(this)) {
        this.context.update(append(this));
      }
    }

    dismiss() {
      this.assertContextIsPresent();
      const dropdowns = get(this.context);
      if (dropdowns.includes(this)) {
        this.context.set(dropdowns.filter((entry) => entry !== this));
        this.dispatch('dismiss');
      }
    }

    assertContextIsPresent() {
      if (this.context === undefined) {
        throw new Error('DropdownRoot context is missing. Did you forget to wrap your component in a DropdownRoot?');
      }
    }
  }

  export const useDropdowns = () => {
    const dropdowns = getContext(DROPDOWNS);
    return (...args) => new Entry(dropdowns, ...args);
  };
</script>

<script>
  import Provider from '../Provider';
  import DropdownContainer from './DropdownContainer.svelte';

  const dropdowns = writable([]);
</script>

<Provider key={DROPDOWNS} value={dropdowns}>
  <slot />

  {#each $dropdowns as dropdown (dropdown)}
    <DropdownContainer {dropdown} />
  {/each}
</Provider>
